// A carrier (UPS, USPS, FedEx...) can offer several shipping methods
// (Ground, Priority, Express...), each its own real quoted price. The
// backend returns one flat list of (carrier, serviceLevel, amount) tuples --
// grouping them here lets the UI offer "pick a carrier, then a shipping
// method within it" instead of one combined list mixing both together.

export interface RateOption {
  rateId: string;
  amount: string;
  carrier: string | null;
  serviceLevel: string | null;
  estimatedDays: number | null;
}

export interface CarrierGroup {
  carrier: string;
  // Sorted cheapest-first within the carrier.
  rates: RateOption[];
}

// Carriers themselves are ordered by their own cheapest option, so the
// first group's first rate is always the single overall-cheapest choice --
// matches the existing "default to cheapest" behavior callers rely on.
export function groupRatesByCarrier(rates: RateOption[]): CarrierGroup[] {
  const byCarrier = new Map<string, RateOption[]>();
  for (const rate of rates) {
    const key = rate.carrier || 'Other';
    if (!byCarrier.has(key)) byCarrier.set(key, []);
    byCarrier.get(key)!.push(rate);
  }

  return Array.from(byCarrier.entries())
    .map(([carrier, carrierRates]) => ({
      carrier,
      rates: [...carrierRates].sort((a, b) => Number(a.amount) - Number(b.amount)),
    }))
    .sort((a, b) => Number(a.rates[0].amount) - Number(b.rates[0].amount));
}
